export default __webpack_public_path__ + "static/media/K2D-MediumItalic.c8fec679.ttf";